import { formatPrice } from "@/lib/api";

// Builds the pre-filled WhatsApp URL for an order (cash or paid-by-card).
export function buildWaUrl({ items, address, notes, settings, payment, deliveryFee = 0 }) {
  const lines = items.map(
    (i) => `• ${i.quantity} × ${i.name} — ${formatPrice(i.price * i.quantity)}`
  );
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const grandTotal = subtotal + Number(deliveryFee || 0);
  const store = settings?.store_name || "Boutique";
  let text = `Bonjour ${store} 👋\n\nJe souhaite commander :\n${lines.join("\n")}\n\n`;
  text += `Sous-total : ${formatPrice(subtotal)}\n`;
  text += `🚚 Livraison : ${Number(deliveryFee || 0) > 0 ? formatPrice(deliveryFee) : "Offerte"}\n`;
  text += `*Total : ${formatPrice(grandTotal)}*\n`;

  if (payment?.method === "card") {
    text += `💳 Paiement par carte\n\n`;
  } else {
    text += `💵 Paiement en espèces à la livraison\n\n`;
  }
  text += `📍 Adresse de livraison : ${address}`;
  if (notes) text += `\n📝 Notes : ${notes}`;

  const phone = (settings?.whatsapp_number || "").replace(/[^0-9]/g, "");
  return { url: `https://wa.me/${phone}?text=${encodeURIComponent(text)}`, phone };
}
